<section class="hero">
  <p class="eyebrow">{{ text.homeEyebrow }}</p>
  <h1>{{ text.homeTitle }}</h1>
  <p class="lead">{{ text.homeLead }}</p>
  <div class="trust">
    <span aria-hidden="true">◆</span>
    <p>
      <strong>{{ text.trustTitle }}</strong>
      <small>{{ text.trustText }}</small>
      <small>{{ text.trustPhrase }}</small>
    </p>
  </div>
</section>
<ng-template #footer>
  <div class="home-footer">
    @if (termsChanged) {
      <div class="home-terms" role="status">
        <p>
          <b>{{ text.changedTitle }}</b> {{ text.changedText }}
          <span class="home-terms-links">
            <button type="button" class="home-legal-link" (click)="openLegal('terms')">
              {{ text.terms }}
            </button>
            <button type="button" class="home-legal-link" (click)="openLegal('privacy')">
              {{ text.privacy }}
            </button>
          </span>
        </p>
        <button type="button" class="home-terms-ok" (click)="acknowledgeTerms()">
          {{ text.understood }}
        </button>
      </div>
    }
    <app-button variant="gold" [disabled]="initializing" (pressed)="start()">{{
      startLabel
    }}</app-button>
    @if (!initializing && !resumeAvailable) {
      <p class="home-legal">
        @for (part of acceptLine; track $index) {
          @if (part.link; as document) {
            <button type="button" class="home-legal-link" (click)="openLegal(document)">
              {{ part.text }}
            </button>
          } @else {
            <span>{{ part.text }}</span>
          }
        }
      </p>
      @if (nativeApp) {
        <!-- In the apps, nothing of a browser's storage came along: a backup brings the will back. -->
        <p class="home-native-restore">{{ text.nativeRestore }}</p>
      }
      <button type="button" class="home-restore" (click)="restore()">{{ text.homeRestore }}</button>
    }
    <p class="home-credit">{{ text.homeCredit }}</p>
  </div>
</ng-template>
